export const LicenseTypes = {
  ETG: 'ETG',
  ETM: 'ETM',
};

export const LICENSE_TYPES_DATA = {
  [LicenseTypes.ETG]: {
    abbr: LicenseTypes.ETG,
    descr: 'Permis voiture',
    category: 'B',
  },
  [LicenseTypes.ETM]: {
    abbr: LicenseTypes.ETM,
    descr: 'Permis moto',
    category: 'A',
  },
};

export const LICENSE_TYPES_SELECT_DATA = [
  {
    id: [LicenseTypes.ETG],
    name: `Code voiture (${LicenseTypes.ETG})`,
  },
  {
    id: [LicenseTypes.ETM],
    name: `Code moto (${LicenseTypes.ETM})`,
  },
];
